
        //login popup redirection 
        class LoginRedirection extends HTMLElement {
        constructor() {
            super();
            this.LoginRedirectionEle = this.querySelector('.login-redirection__button');
            this.LoginRedirectionEle.addEventListener('click', (event) => {
            this.redirection(event);
            });
        }

        redirection(event) {
            this.redirectionUrl = event.target.dataset.pageUrl;
            sessionStorage.setItem('redirectionPath', this.redirectionUrl);
            console.log(this.redirectionUrl);
            window.location.href = '/account';
            console.log("Button Clicked");
        }
        }

        customElements.define('login-redirection', LoginRedirection);
